module.exports = __webpack_public_path__ + "img/menu-black-icon.d8637dad.svg";